module.exports = __webpack_public_path__ + "img/testimonial-avatar-3.47eb940d.jpg";